//libs
import React, { memo, useState, useEffect } from "react";

//constants
import { BRAND_UI_TYPES } from "./constants";

//styles
import { BrandInitials, InitialsContainer } from "./styles";

//types
import { IBrandsHeaderProps } from "./types";

// helpers
import { bucketizeBrands } from "shared/components/Header/helpers";

const BrandsHeader = ({
    availableBrands,
    setFilteredBrands,
    allInitials,
    setSelectedCategory,
}: IBrandsHeaderProps) => {
    const [selectedInitial, setSelectedInitial] = useState("");

    useEffect(() => {
        setSelectedInitial("");
    }, [availableBrands]);

    const checkAvailability = (character: string) => {
        return Object.keys(availableBrands).includes(character);
    };

    const isSelected = (character: string) => {
        return character === selectedInitial;
    };

    const generateBrandType = (character: string) => {
        if (isSelected(character)) {
            return BRAND_UI_TYPES.SELECTED;
        }
        return checkAvailability(character) ? BRAND_UI_TYPES.AVAILABLE : BRAND_UI_TYPES.DEFAULT;
    };

    const updateFilteredBrands = (character: string) => {
        if (availableBrands[character] === undefined) {
            return;
        }

        setFilteredBrands(bucketizeBrands(availableBrands[character]));
        setSelectedInitial(character);
        setSelectedCategory(character);
    };

    return (
        <InitialsContainer>
            {allInitials.map((character, index) => {
                return (
                    <BrandInitials
                        brandUIType={generateBrandType(character)}
                        key={index}
                        onClick={() => {
                            updateFilteredBrands(character);
                        }}
                    >
                        {character}
                    </BrandInitials>
                );
            })}
        </InitialsContainer>
    );
};

export default memo(BrandsHeader);
